module.exports = __webpack_public_path__ + "img/map_d200605.b72bc619.gif";